import { computed, unref } from "vue";

import { isProductReadinessEnabled } from "@/utils/accountProductFlags";

/**
 * The payload's `readiness_enabled` is authoritative (`readiness_module_enabled` is the context's
 * legacy alias of it); the account product flag applies only when neither key is present.
 */
export function resolveReadinessEnabled(payload) {
  if (payload && typeof payload === "object") {
    if (typeof payload.readiness_enabled === "boolean") return payload.readiness_enabled;
    if (typeof payload.readiness_module_enabled === "boolean") {
      return payload.readiness_module_enabled;
    }
  }
  return isProductReadinessEnabled();
}

export function useReadinessEnabled(payload) {
  return computed(() => resolveReadinessEnabled(unref(payload)));
}
